import { render, staticRenderFns } from "./dataListZjxmJggd.vue?vue&type=template&id=30e1c7bb&scoped=true"
import script from "./dataListZjxmJggd.vue?vue&type=script&lang=js"
export * from "./dataListZjxmJggd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e1c7bb",
  null
  
)

export default component.exports